import React from "react";
import { Line } from "react-chartjs-2";
import ChartCard from "../ChartCard";
import { withLineChartStyles } from "../chartStyles";

const OccupancyChart = ({ occupancyChart }) => {
  return (
    <ChartCard chart={occupancyChart}>
      <Line
        data={withLineChartStyles(occupancyChart.data)}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: true,
              suggestedMax: 100,
              ticks: {
                callback: function (value) {
                  return `${value} %`;
                },
              },
            },
          },
        }}
      />
    </ChartCard>
  );
};

export default OccupancyChart;
